"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExportsModel = /** @class */ (function () {
    function ExportsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/exports",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    ExportsModel.prototype.extract = function (result) {
        return result.data;
    };
    ExportsModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    ExportsModel.prototype.fetchReport = function (report_type) {
        return this.$http
            .get(this.URLS.FETCH + "?export_type=" + report_type)
            .then(this.cacheResults);
    };
    return ExportsModel;
}());
ExportsModel.$inject = ["$http", "APPURL"];
exports.default = ExportsModel;
